"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.OnOffListItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Intl = _interopRequireDefault(require("../../proptypes/Intl"));
var _ListItemAvatar = require("../ListItemAvatar");
var _ListItemBoxText = _interopRequireDefault(require("../ListItemBoxText"));
var _ListItemNavigationIcon = _interopRequireDefault(require("../ListItemNavigationIcon"));
var _ListItem = _interopRequireDefault(require("../ListItem"));
var _getColor = require("./getColor");
var _Typography = require("../../Typography");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var OnOffListItem = exports.OnOffListItem = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var avatarProps = _ref.avatarProps,
    className = _ref.className,
    dataTestId = _ref.dataTestId,
    disabled = _ref.disabled,
    divider = _ref.divider,
    Icon = _ref.icon,
    id = _ref.id,
    onClick = _ref.onClick,
    secondaryText = _ref.secondaryText,
    selected = _ref.selected,
    showNavigationIcon = _ref.showNavigationIcon,
    text = _ref.text,
    textDataTestId = _ref.textDataTestId,
    a11yProps = _ref.a11yProps,
    renderCustomItem = _ref.renderCustomItem;
  return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
    avatarProps: avatarProps,
    button: true,
    className: className,
    dataTestId: dataTestId,
    disabled: disabled,
    divider: divider,
    icon: Icon && /*#__PURE__*/_react["default"].createElement(Icon, {
      color: (0, _getColor.getColor)({
        disabled: disabled,
        selected: selected
      })
    }),
    id: id,
    onClick: onClick,
    selected: selected,
    a11yProps: a11yProps,
    ref: ref
  }, renderCustomItem ? renderCustomItem({
    avatarProps: avatarProps,
    className: className,
    dataTestId: dataTestId,
    disabled: disabled,
    divider: divider,
    icon: Icon,
    id: id,
    onClick: onClick,
    secondaryText: secondaryText,
    selected: selected,
    showNavigationIcon: showNavigationIcon,
    text: text,
    textDataTestId: textDataTestId,
    a11yProps: a11yProps
  }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ListItemBoxText["default"], {
    text: text,
    secondaryText: secondaryText,
    textDataTestId: textDataTestId,
    level: selected ? _Typography.Level.BODY_STRONG : _Typography.Level.BODY,
    hasLeftContent: Boolean(avatarProps) || Boolean(Icon),
    hasRightContent: showNavigationIcon,
    disabled: disabled
  }), showNavigationIcon && /*#__PURE__*/_react["default"].createElement(_ListItemNavigationIcon["default"], {
    color: (0, _getColor.getColor)({
      disabled: disabled,
      selected: selected
    })
  })));
});
OnOffListItem.propTypes = {
  text: _propTypes["default"].oneOfType([_propTypes["default"].string, _Intl["default"]]).isRequired,
  avatarProps: _propTypes["default"].shape(_ListItemAvatar.ListItemAvatarPropTypes),
  className: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  divider: _propTypes["default"].bool,
  icon: _propTypes["default"].elementType,
  id: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  secondaryText: _propTypes["default"].oneOfType([_propTypes["default"].string, _Intl["default"]]),
  selected: _propTypes["default"].bool,
  showNavigationIcon: _propTypes["default"].bool,
  textDataTestId: _propTypes["default"].string,
  a11yProps: _propTypes["default"].object,
  renderCustomItem: _propTypes["default"].func
};
var _default = exports["default"] = OnOffListItem;